package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

// Like PhoneticKeyboardContent, but the prompt is a real inscription photo instead of an MdCWord.
// The image is referenced by its drawable code (see InscriptionImages) rather than by a
// DrawableResource, so it can be stored as-is in the serializable WrongAnswerRecord.
data class ImageKeyboardContent @OptIn(ExperimentalUuidApi::class) constructor(
    val imageCode: String,
    val reading: List<String>,
    // Shown only in the feedback after answering; null when replayed from a saved mistake.
    val translation: StringResource? = null,
    override val id: String = Uuid.random().toHexDashString(),
) : IQuizContent, ICountableQuiz
